'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginOrExistingUserLink = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _FormattedReactMessage = require('I18n/components/FormattedReactMessage');

var _FormattedReactMessage2 = _interopRequireDefault(_FormattedReactMessage);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _RouterActions = require('../../actions/RouterActions');

var _Auth = require('../../selectors/Auth');

var _loginRedirect = require('./loginRedirect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginOrExistingUserLink = exports.LoginOrExistingUserLink = function (_React$Component) {
  _inherits(LoginOrExistingUserLink, _React$Component);

  function LoginOrExistingUserLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LoginOrExistingUserLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginOrExistingUserLink.__proto__ || Object.getPrototypeOf(LoginOrExistingUserLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleGoToExistingUser = function () {
      _this.props.goToStep('existing-user');
    }, _this.handleLoginRedirect = function () {
      (0, _loginRedirect.loginRedirect)(_this.props.user);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LoginOrExistingUserLink, [{
    key: 'renderLoginLink',
    value: function renderLoginLink() {
      return _react2.default.createElement(_FormattedReactMessage2.default, {
        message: 'core.landingPage.core.afterSubmit',
        options: {
          link: _react2.default.createElement(
            _UILink2.default,
            {
              key: 'login-link',
              'data-selenium': 'login',
              onClick: this.handleLoginRedirect
            },
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'core.landingPage.core.logIn' })
          )
        }
      });
    }
  }, {
    key: 'renderExistingUserLink',
    value: function renderExistingUserLink() {
      return _react2.default.createElement(
        _UILink2.default,
        {
          'data-selenium': 'goBackExistingUser',
          onClick: this.handleGoToExistingUser
        },
        _react2.default.createElement(_UIIcon2.default, { name: 'left' }),
        _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'core.accountDetails.goBackExistingUser' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.authDetected ? this.renderExistingUserLink() : this.renderLoginLink();
    }
  }]);

  return LoginOrExistingUserLink;
}(_react2.default.Component);

LoginOrExistingUserLink.propTypes = {
  user: _propTypes2.default.object.isRequired,
  goToStep: _propTypes2.default.func.isRequired,
  authDetected: _propTypes2.default.bool.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.userInfo,
    authDetected: (0, _Auth.didDetectAuth)(state)
  };
};

var mapDispatchToProps = { goToStep: _RouterActions.goToStep };

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginOrExistingUserLink);